package br.com.texeratx.boardgametimeapp.core.image

import androidx.compose.foundation.Image
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.toComposeImageBitmap
import org.jetbrains.skia.Image as SkiaImage

@Composable
actual fun LocalImagePreview(
    bytes: ByteArray,
    modifier: Modifier,
    contentDescription: String?
) {
    val bitmap = remember(bytes) {
        SkiaImage.makeFromEncoded(bytes).toComposeImageBitmap()
    }

    Image(
        bitmap = bitmap,
        contentDescription = contentDescription,
        modifier = modifier
    )
}
